import React, { useState } from 'react'

import { api_gateway } from '../../../conexoes/api'
import decryptJWT from '../../../utils/decryptJWT'
import ModalImportarArquivo from '../modalImportarArquivo/importarArquivo'

let idInserido = ''
let arquivos
let data

const dadosJSONXLS_dsp = [['linha'], ["'"]]

const dadosJSONCSV_dsp = [
  {
    linha: "'"
  }
]

const cssClassesListaArquivosDsp = {
  div_class: 'container-importar-descricao-lista-arquivos',
  p_class: 'tituloLista-importar-arquivo',
  li_class: 'lista-importar-arquivo',
  li_p_class: 'listaNome-importar-arquivo'
}

export default function AtivacaoLinhasAWS(props) {
  const [revelarVerificarWhatsapp, setRevelarVerificarWhatsapp] =
    useState(false)
  const [dadosArquivoErros, setDadosArquivoErros] = useState(false)
  const [spinAtivo, setSpinAtivo] = useState(false)

  async function processUploadDsp(uploadedFile, thisObj) {
    setSpinAtivo(true)
    arquivos = uploadedFile
    data = new FormData()
    data.append('file', arquivos.file)
    data.append('cd_usuario', decryptJWT('codigo'))

    data.append('cd_pav_evento_parametro_tipo', 7)

    const config = {
      onUploadProgress: (e) => {
        const progress = parseInt(Math.round((e.loaded * 100) / e.total))

        thisObj.updateFile(uploadedFile.id, {
          progress
        })
      }
    }

    await api_gateway
      .post('s3/leitura/arquivo', data, config)
      .then((response) => {
        setSpinAtivo(false)
        if (response.data.status === 200) {
          idInserido = response.data.idInserido
          thisObj.updateFile(uploadedFile.id, {
            uploaded: true,
            id: response.data._id,
            url: response.data.url
          })
          thisObj.setState({
            dadosArquivo: thisObj.state.dadosArquivo.concat(response.data.dados)
          })
        } else {
          setSpinAtivo(false)
          thisObj.updateFile(uploadedFile.id, {
            error: true,
            uploaded: false
          })
        }
        thisObj.updateFile(uploadedFile.id, {
          uploaded: true,
          id: response.data._id,
          url: response.data.url
        })
      })
      .catch(() => {
        setSpinAtivo(false)
        thisObj.updateFile(uploadedFile.id, {
          error: true
        })
      })
  }

  async function uploadTabelaDsp() {
    setDadosArquivoErros(false)

    const cdCliente = decryptJWT('codigoCliente')
    const cdUsuario = decryptJWT('codigo')
    return await api_gateway.post(
      `s3/filtrar/whatsApp?codigo_cliente=${cdCliente}&codigo_usuario=${cdUsuario}`,
      data
    )
  }

  function getMensagemErroSalvar(error) {
    const mensagemErro = error?.response?.data?.msg || 'Erro no servidor'

    setDadosArquivoErros(mensagemErro)
    return mensagemErro
  }
  return (
    <ModalImportarArquivo
      dispositivos
      verificacaoWhatsapp
      apenasXLSX
      titulo="Verificar linhas com whatsapp"
      singleFile
      revelarModal={revelarVerificarWhatsapp}
      closeModal={() => props.closeModal()}
      setSpinAtivo={setSpinAtivo}
      spinAtivo={spinAtivo}
      dadosJSONXLS={dadosJSONXLS_dsp}
      dadosJSONCSV={dadosJSONCSV_dsp}
      processUpload={processUploadDsp}
      cssClassesListaArquivos={cssClassesListaArquivosDsp}
      renderizar={props.renderizar}
      setRenderizar={props.setRenderizar}
      uploadTabela={uploadTabelaDsp}
      getMensagemErroSalvar={getMensagemErroSalvar}
      temDadosArquivoErros={!!dadosArquivoErros}
      mensagemSucesso={
        <p>
          A verificação será concluída em alguns instantes. Assim que o arquivo
          estiver pronto, ficará disponível para download na tela de{' '}
          <b>Relatórios</b>
        </p>
      }
    />
  )
}
